


































    import {Component, Prop, Vue} from "vue-property-decorator";
    import {Guid} from "guid-typescript";
    import Modal from "@/components/Modal.vue";
    import {Action} from "vuex-class";
    import {ErrorToastSettings, SuccessToastSettings} from "@/api/Utils";
    import {emptyWebhook, Webhook, WebhookApi} from "@/api/v1/WebhookApi";

    @Component({components: {Modal}})
    export default class CreateOrUpdateWebhookSubscription extends Vue {
        @Prop({type: String, required: true}) readonly clientId!: Guid;
        @Prop({type: String, default: null}) readonly webhookId!: Guid | null;

        @Action invalidateWebhooks!: () => any;

        webhook: Webhook = emptyWebhook();

        done() {
            this.$emit("done");
        }

        submit() {
            if (this.webhookId) {
                WebhookApi.update(this.clientId, this.webhookId, this.webhook)
                    .then(() => {
                        this.$parent!!.$bvToast.toast(this.$t("webhook-updated").toString(), SuccessToastSettings);
                        this.done();
                        this.invalidateWebhooks();
                    })
                    .catch(err => {
                        this.$parent!!.$bvToast.toast(this.$t("failed-update-webhook").toString(), ErrorToastSettings);

                        throw err;
                    });
            } else {
                WebhookApi.create(this.clientId, this.webhook)
                    .then(() => {
                        this.$parent!!.$bvToast.toast(this.$t("webhook-updated").toString(), SuccessToastSettings);
                        this.done();
                        this.invalidateWebhooks();
                    })
                    .catch(err => {
                        this.$parent!!.$bvToast.toast(this.$t("failed-create-webhook").toString(), ErrorToastSettings);

                        throw err;
                    });
            }
        }

        created() {
            if (this.webhookId) {
                WebhookApi.findById(this.clientId, this.webhookId)
                    .then(data => {
                        this.webhook = data;
                    });
            }
        }
    }
